<template>
  <section>
    <land-banner
      :items="banItems"
      :height="classify.height"
      :points="classify.points"
      :cycle="classify.cycle"
      :interval="classify.interval"
      :hide-delimiters="wdHideDelimiters"
      :show-arrows="wdShowArrows"
      @click="onClick"
    />
    <land-section id="hotcenter" space="40">
      <v-container style="max-width: 1800px;">
        <v-card class="mb-6" color="transparent" flat tile>
          <v-tabs
            v-model="currTab"
            background-color="transparent"
            class="d-flex flex-row justify-center align-center"
            @change="onTabChange"
          >
            <v-tab
              v-for="(tab, tabIndex) in tabList"
              :key="tabIndex"
              :value="tab.name"
              :href="`#${tab.name}`"
              class="text-h6"
            >
              {{ tab.title }}
            </v-tab>
          </v-tabs>
        </v-card>
        <!-- 筛选按钮 -->
        <div class="btn-content" v-if="currTab != 'activity'">
          <div class="flex-row items-center">
            <div
              class="new-icon flex-row items-center"
              v-for="(item, index) in hotBtn"
              :key="index"
              :class="index == h ? 'colorB' : ''"
              @click="choose(index)"
            >
              <img
                src="../../assets/new-icon.png"
                alt=""
                v-if="index == 0 && h == 1"
              />
              <img
                src="../../assets/new-icon-r.png"
                alt=""
                v-if="index == 0 && h == 0"
              />
              <img
                src="../../assets/hot-icon.png"
                alt=""
                v-if="index == 1 && h == 0"
              />
              <img
                src="../../assets/hot-icon-r.png"
                alt=""
                v-if="index == 1 && h == 1"
              />
              {{ item }}
            </div>
          </div>
        </div>
        <v-row justify="center">
          <v-col cols="12">
            <v-tabs-items v-model="currTab">
              <v-tab-item value="image" class="grey lighten-4">
                <hot-images :sort="parentSort" ref="hotImages" />
              </v-tab-item>

              <v-tab-item value="video" class="grey lighten-4">
                <hot-videos :sort="parentSort" ref="hotVideos" />
              </v-tab-item>

              <v-tab-item value="article" class="grey lighten-4">
                <hot-articles :sort="parentSort" ref="hotArticles" />
              </v-tab-item>
              <v-tab-item value="activity" class="grey lighten-4">
                <hot-activities ref="hotActivities" />
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-container>
    </land-section>

    <!-- <section-foot /> -->
    <el-dialog
      :title="dlgForward.title"
      :visible.sync="dlgForward.visible"
      :width="dlgForward.width"
    >
      <el-form
        :ref="dlgForward.form"
        :model="forwardData"
        :rules="forwardRules"
        label-position="left"
        label-width="80px"
      >
        <el-form-item label="内容标题" prop="content">
          <el-input v-model="forwardData.content" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="onForwardCancel">
          取消
        </el-button>
        <el-button type="primary" @click="onForwardConfirm">
          确定
        </el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import web from "@/api/web/co.web";

import mixHotBanner from "@/pages/mixins/hot/mix.hot.banner";
import mixHotBoot from "@/pages/mixins/hot/mix.hot.boot";

export default {
  metaInfo: { title: "热门" },
  components: {
    HotActivities: () => import("@/pages/sections/hot/HotActivities.vue"),
    HotArticles: () => import("@/pages/sections/hot/HotArticles.vue"),
    HotImages: () => import("@/pages/sections/hot/HotImages.vue"),
    HotVideos: () => import("@/pages/sections/hot/HotVideos.vue")
    // SectionFoot: () => import('@/pages/sections/Foot.vue')
  },
  mixins: [mixHotBanner, mixHotBoot],
  data() {
    return {
      hotBtn: ["最新排序", "最热排序"],
      h: 1,
      parentSort: "top_flag"
    };
  },
  created() {
    this.initBannerParams({
      type: web.comm.BannerTypes.HOT_MAJOR
    });
    this.loadBanners();

    // this.configContents()
    // this.loadContents()
  },
  methods: {
    choose(index) {
      this.h = index;
      if (index == 0) {
        this.parentSort = "";
      } else {
        this.parentSort = "top_flag";
      }
      if (this.currTab == "image") {
        setTimeout(() => {
          this.$refs.hotImages.configParams();
          this.$refs.hotImages.loadContents();
        }, 20);
      }
      if (this.currTab == "video") {
        setTimeout(() => {
          this.$refs.hotVideos.configParams();
          this.$refs.hotVideos.loadContents();
        }, 20);
      }
      if (this.currTab == "article") {
        setTimeout(() => {
          this.$refs.hotArticles.configParams();
          this.$refs.hotArticles.loadContents();
        }, 20);
      }
      // if (this.currTab == "activity") {
      //   setTimeout(() => {
      //     this.$refs.hotActivities.configParams();
      //     this.$refs.hotActivities.loadContents();
      //   }, 20);
      // }
    },
    onTabChange(e) {
      this.h = 1;
      this.parentSort = "top_flag";
    }
  }
};
</script>
<style scoped>
.btn-content {
  display: flex;
  justify-content: flex-end;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 20px;
}
.btn-content img {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}
.new-icon {
  margin-right: 26px;
  cursor: pointer;
  color: #9e9e9e;
}
.new-icon:last-child {
  margin-right: 0;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.items-center {
  align-items: center;
}
.colorB {
  color: #000 !important;
}
</style>
